if (!customElements.get('newsletter-modal')) {
  customElements.define('newsletter-modal', class ProductModel extends HTMLElement {
    constructor() {
      super();

      this.key = this.dataset.storageKey;
      this.canSetKey = false;

      // The lead modal trigger ([data-open-lead-modal]) is handled
      // globally by <lead-form>, which also closes this popup on open.

      // Debug
      // console.log(this.dataset)

      // Check first if we have test mode
      if (this.dataset.testMode === 'true') {
        this.openModal(0);
        return;
      }

      // Check if we have form and if user posted the form
      this.form = this.querySelector('form');
      if (this.form && window.location.href.includes(`customer_posted=true#${this.form.id}`) && !sessionStorage.getItem(this.key + '_submitted')) {
        sessionStorage.setItem(this.key + '_submitted', true);
        this.openModal(0);
        return;
      }
      
      // Check if we can open the popup at all
      // First we check if frequency is per session and if session storage has the key
      if (this.dataset.frequency === 'once' && sessionStorage.getItem(this.key)) {
        // Is seen in the session => quit
        return;
      } else if (this.dataset.frequency === 'once') {
        // Is not seen in the session => we can proceed
        this.canSetKey = 'session';
        this.openModalIfAllowed();
        return;
      }

      if (!localStorage.getItem(this.key)) {
        // Popup not seen, show it
        this.canSetKey = 'local';
        this.openModalIfAllowed()
        return;
      } else if (localStorage.getItem(this.key)) {
        // Popup is seen, but verify if we can see it again
        const frequency = parseInt(this.dataset.frequency.split('_')[0]); // e.g. 3_days => 3

        const timeNow = this.generateTimeStamp();
        const timeThen = parseInt(localStorage.getItem(this.key));
        const timeDiffInDays = (timeNow - timeThen) / (1000 * 3600 * 24);

        /**
         * Testing:
         * localStorage.setItem('woolman-theme-myshopify-com-newsletter-modal-1_day', new Date('1996-1-1').getTime())
         */

        if (timeDiffInDays >= frequency) {
          // We can show it again
          this.canSetKey = 'local';
          this.openModalIfAllowed()
        }
        return;
      }
    }

    /**
     * Checks if cookie management app is enabled and if user has accepted tracking and then opens modal based on information received
     */
    openModalIfAllowed() {
      if(!window.Shopify?.customerPrivacy) {
        this.openModal()
      } else {
        if (window.Shopify?.customerPrivacy?.userCanBeTracked() || window.Shopify?.customerPrivacy?.userDataCanBeSold()) {
          this.openModal()
        } else {
          document.addEventListener('trackingConsentAccepted', () => {
            this.openModal()
          })
        }
      }
    }

    /**
     * Opens the modal with provided delay
     * @param {number=} delay 
     */
    openModal(delay) {
      if (delay === 0) {
        this.commitOpen();
        return;
      } else {
        setTimeout(() => {
          this.commitOpen();
        }, parseInt(this.dataset.delay));
      }
    }

    /**
     * Marks the popup as seen (per frequency) and shows it — unless the
     * lead sign-up modal is already open, in which case we skip silently
     * so the two modals do not overlap. We deliberately do NOT set the storage
     * key when skipping, so the popup can still appear on a later eligible load.
     */
    commitOpen() {
      if (this.isLeadModalOpen()) return;

      if (this.canSetKey === 'session') {
        sessionStorage.setItem(this.key, this.generateTimeStamp());
      } else if (this.canSetKey === 'local') {
        localStorage.setItem(this.key, this.generateTimeStamp());
      }
      Woolman.ModalsAndDrawers.showModalOrDrawer(this.id);
    }

    /**
     * True when the lead sign-up modal (<lead-form>) is currently open.
     * Woolman flags an open modal with the `is-open` class (see global.js).
     */
    isLeadModalOpen() {
      const leadModal = document.getElementById('modal-lead');
      return !!(leadModal && leadModal.classList.contains('is-open'));
    }

    /**
     * Generate timestamp
     * @returns {number} UNIX Timestamp
     */
    generateTimeStamp() {
      return new Date().getTime();
    }
  });
}

/**
 * Copy-to-clipboard for the promo-code chip rendered by the `discount`
 * block in sections/modal-newsletter.liquid. Bound once at document level
 * so it keeps working regardless of how/when the modal is shown.
 */
if (!window.__newsletterDiscountCopyBound) {
  window.__newsletterDiscountCopyBound = true;
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-copy-code]');
    if (!chip) return;
    const done = () => {
      chip.classList.add('is-copied');
      setTimeout(() => chip.classList.remove('is-copied'), 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(chip.dataset.copyCode).then(done).catch(done);
    } else {
      done();
    }
  });
}